export const mobileWidth = '1100px';